import { useSyncExternalStore } from "react";
import type { ModelPickerHost } from "./catalog";
import {
  getModelPickerSelectionRevision,
  resolveModelPickerOverride,
  subscribeModelPickerSelection,
} from "./selectionStore";

export function useModelPickerOverride(host: ModelPickerHost) {
  useSyncExternalStore(
    subscribeModelPickerSelection,
    getModelPickerSelectionRevision,
    () => 0
  );
  return resolveModelPickerOverride(host);
}
